import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Instagram, ArrowUpRight } from "lucide-react";
import { BRAND, NAV, HOURS } from "@/lib/content";
import api from "@/lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { pathname } = useLocation();
  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try { await api.post("/newsletter", { email, source: "footer" }); toast.success("You're on the list. Welcome to ChiCha."); setEmail(""); }
    catch { toast.error("Could not subscribe. Try again."); } finally { setLoading(false); }
  };

  return (
    <footer data-testid="footer" className="relative z-[2] mt-10">
      <div className="max-w-[1300px] mx-auto px-5 md:px-8">
        <div className="card-lux p-8 md:p-14">
          <div className="grid lg:grid-cols-[1.4fr_1fr_1fr] gap-12 pb-12 border-b border-black/10">
            <div>
              <img src={BRAND.logo} alt="ChiCha Lounge DC" className="h-12 w-auto mb-5" />
              <p className="text-neutral-500 text-sm leading-relaxed max-w-sm">{BRAND.tagline}. Premium hookah, craft cocktails & VIP nightlife in the heart of U Street.</p>
              <form onSubmit={subscribe} className="flex items-center bg-neutral-100 rounded-full overflow-hidden pl-5 pr-1.5 py-1.5 mt-6 max-w-sm">
                <input data-testid="newsletter-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email" className="bg-transparent flex-1 text-sm text-neutral-900 placeholder:text-neutral-400 outline-none py-2" />
                <button data-testid="newsletter-submit" disabled={loading} className="btn-gold !py-2 !px-4 text-sm shrink-0">Join <ArrowUpRight size={15} /></button>
              </form>
              <a href={BRAND.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="inline-flex items-center gap-2 mt-6 text-neutral-900 text-sm hover:opacity-60"><Instagram size={18} /> @chichalounge</a>
            </div>
            <div>
              <h4 className="overline mb-5">Explore</h4>
              <ul className="space-y-2.5">
                {NAV.map((n) => <li key={n.to}><Link to={n.to} data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`} className="text-neutral-500 hover:text-neutral-900 text-sm transition-colors">{n.label}</Link></li>)}
              </ul>
            </div>
            <div>
              <h4 className="overline mb-5">Hours</h4>
              <ul className="space-y-1.5">
                {HOURS.map((h) => <li key={h.day} className="flex justify-between text-sm gap-4"><span className="text-neutral-500">{h.day}</span><span className="text-neutral-400">{h.time}</span></li>)}
              </ul>
              <p className="text-neutral-500 text-sm mt-5">{BRAND.address}</p>
              <a href={`tel:${BRAND.phoneRaw}`} className="text-neutral-500 hover:text-neutral-900 text-sm">{BRAND.phone}</a>
            </div>
          </div>
          <div className="pt-7 flex flex-col md:flex-row items-center justify-between gap-4 text-neutral-400 text-xs">
            <p>© {new Date().getFullYear()} ChiCha Lounge · Washington, DC</p>
            <div className="flex gap-6">
              <Link to="/private-events" className="hover:text-neutral-900">Private Events</Link>
              <Link to="/reservations" className="hover:text-neutral-900">Reservations</Link>
              {(pathname === "/gallery" || pathname === "/") && (
                <Link to="/admin/login" data-testid="footer-admin" className="hover:text-neutral-900">Staff Login</Link>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="h-10" />
    </footer>
  );
}
